import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Info, PlaceOutlined, DescriptionOutlined } from "@material-ui/icons";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import ModalConfirmacao from "../../components/ModalConfirmacao";
import Swal from "sweetalert2";
import Button from "../../components/Button";
import * as viagem_crud from "../../crud/viagem.crud";
import { formatDateLocal, formatTimeLocal, formatBRL } from "../../utils/Utils";
import { obterTipoIconeBandeira } from "../../utils/cartaoUtils";
import { obterStatusInfo, LABEL_TIPO_VEICULO } from "./ViagemUtils";
import styles from "../../styles/Viagem.module.scss";
import Breadcrumb from "../../components/Breadcrumb";
import { CircularProgress } from "@material-ui/core";

function IconeDownload() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66667 9.64583C6.55556 9.64583 6.45139 9.62847 6.35417 9.59375C6.25694 9.55903 6.16667 9.5 6.08333 9.41667L3.08333 6.41667C2.93056 6.26389 2.85417 6.06944 2.85417 5.83333C2.85417 5.59722 2.93056 5.40278 3.08333 5.25C3.23611 5.09722 3.43403 5.01736 3.67708 5.01042C3.92014 5.00347 4.11806 5.07639 4.27083 5.22917L5.83333 6.79167V0.833333C5.83333 0.597222 5.91319 0.399306 6.07292 0.239583C6.23264 0.0798611 6.43056 0 6.66667 0C6.90278 0 7.10069 0.0798611 7.26042 0.239583C7.42014 0.399306 7.5 0.597222 7.5 0.833333V6.79167L9.0625 5.22917C9.21528 5.07639 9.41319 5.00347 9.65625 5.01042C9.89931 5.01736 10.0972 5.09722 10.25 5.25C10.4028 5.40278 10.4792 5.59722 10.4792 5.83333C10.4792 6.06944 10.4028 6.26389 10.25 6.41667L7.25 9.41667C7.16667 9.5 7.07639 9.55903 6.97917 9.59375C6.88194 9.62847 6.77778 9.64583 6.66667 9.64583ZM1.66667 13.3333C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V10C0 9.76389 0.0798611 9.56597 0.239583 9.40625C0.399306 9.24653 0.597222 9.16667 0.833333 9.16667C1.06944 9.16667 1.26736 9.24653 1.42708 9.40625C1.58681 9.56597 1.66667 9.76389 1.66667 10V11.6667H11.6667V10C11.6667 9.76389 11.7465 9.56597 11.9063 9.40625C12.066 9.24653 12.2639 9.16667 12.5 9.16667C12.7361 9.16667 12.934 9.24653 13.0938 9.40625C13.2535 9.56597 13.3333 9.76389 13.3333 10V11.6667C13.3333 12.125 13.1701 12.5174 12.8438 12.8438C12.5174 13.1701 12.125 13.3333 11.6667 13.3333H1.66667Z" fill="currentColor" />
    </svg>
  );
}

class ViagemShow extends Component {
  state = {
    viagem: null,
    loading: true,
    modal_cancelar: false,
    loading_cancelar: false,
    taxa_cancelamento: null,
    modal_passageiros: false,
  };

  componentDidMount() {
    const { id } = this.props.match.params;

    viagem_crud.get(id)
      .then((res) => {
        this.setState({ viagem: res.data, loading: false });
      })
      .catch(() => {
        Swal.fire("Ops!", "Não foi possível carregar os dados da viagem.", "error");
        this.props.history.push("/viagens");
      });
  }

  handleAbrirCancelamento = () => {
    const { id } = this.props.match.params;

    viagem_crud.getTaxaCancelamento(id)
      .then((res) => {
        this.setState({
          taxa_cancelamento: res.data,
          modal_cancelar: true,
        });
      })
      .catch(() => {
        Swal.fire("Ops!", "Não foi possível obter a taxa de cancelamento.", "error");
      });
  };

  handleConfirmarCancelamento = () => {
    const { id } = this.props.match.params;

    this.setState({ loading_cancelar: true });

    viagem_crud.cancelar(id)
      .then(() => {
        this.setState({ modal_cancelar: false, loading_cancelar: false });

        Swal.fire("Viagem cancelada!", "A viagem foi cancelada com sucesso.", "success")
          .then(() => {
            this.props.history.push("/viagens");
          });
      })
      .catch(() => {
        this.setState({ loading_cancelar: false });

        Swal.fire("Ops!", "Não foi possível cancelar a viagem.", "error");
      });
  };

  handleRecibo = () => {
    const { id } = this.props.match.params;

    viagem_crud.gerarRecibo(id)
      .then((res) => {
        Swal.fire("Recibo", res.data.message || "Recibo gerado com sucesso.", "success");
      })
      .catch(() => {
        Swal.fire("Ops!", "Não foi possível gerar o recibo.", "error");
      });
  };

  ehCancelavel = () => {
    const { viagem } = this.state;

    return viagem?.via_status === "SOLICITADA" || viagem?.via_status === "ACEITA";
  };

  renderModalCancelar() {
    const { modal_cancelar, loading_cancelar, taxa_cancelamento } = this.state;

    const descricao = `De acordo com o período da solicitação, o cancelamento resultará em uma taxa de ${taxa_cancelamento?.percentual || 0}% sobre o valor total da viagem. Deseja confirmar o cancelamento?`;

    return (
      <ModalConfirmacao
        aberto={modal_cancelar}
        onFechar={() => this.setState({ modal_cancelar: false })}
        titulo="Tem certeza que deseja cancelar esta viagem?"
        descricao={descricao}
        texto_confirmar="Cancelar viagem"
        texto_cancelar="Voltar"
        variante_confirmar="danger"
        loading={loading_cancelar}
        onConfirmar={this.handleConfirmarCancelamento}
      />
    );
  }

  renderModalPassageiros() {
    const { modal_passageiros, viagem } = this.state;

    if (!modal_passageiros) {
      return null;
    }

    const passageiros = viagem?.passageiros_viagem || [];

    return ReactDOM.createPortal(
      <div className={styles.overlay}>
        <div className={styles.modalLarge}>
          <div className={styles.modalHeader}>
            <p className={styles.modalTitulo}>Relação de passageiros</p>

            <button
              className={styles.modalFechar}
              onClick={() => this.setState({ modal_passageiros: false })}
            >
              ✕
            </button>
          </div>

          {passageiros.map((passageiro, index) => (
            <div key={index}>
              {index > 0 && <span className={styles.passageiroSeparador} />}

              <p className={styles.passageiroLabel}>Passageiro {index + 1}</p>

              <div className={styles.gridDuasColunasModal}>
                <div>
                  <p className={styles.dadoLabel}>Nome completo</p>
                  <p className={styles.dadoValor}>{passageiro.vpa_nome_completo}</p>
                </div>

                <div>
                  <p className={styles.dadoLabel}>Documento</p>
                  <p className={styles.dadoValor}>{passageiro.vpa_documento}</p>
                </div>

                <div>
                  <p className={styles.dadoLabel}>Data de nascimento</p>
                  <p className={styles.dadoValor}>{formatDateLocal(passageiro.vpa_data_nascimento)}</p>
                </div>

                {passageiro.vpa_nome_responsavel && (
                  <div>
                    <p className={styles.dadoLabel}>Responsável</p>
                    <p className={styles.dadoValor}>{passageiro.vpa_nome_responsavel}</p>
                  </div>
                )}
              </div>
            </div>
          ))}

          <div className={styles.modalBotoes}>
            <Button
              variant="default"
              outlined
              size="sm"
              onClick={() => this.setState({ modal_passageiros: false })}
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  renderStatus() {
    const { viagem } = this.state;
    const status_info = obterStatusInfo(viagem.via_status);
    const cancelavel = this.ehCancelavel();

    return (
      <div className={styles.card}>
        <div className={styles.statusHeader}>
          <div className={styles.statusInfo}>
            <p className={styles.statusLabel}>Status da viagem</p>
            <span className={styles[status_info.classeKey]}>{status_info.label}</span>
          </div>

          {cancelavel && (
            <Button
              variant="danger"
              outlined
              size="sm"
              onClick={this.handleAbrirCancelamento}
            >
              Cancelar viagem
            </Button>
          )}

          {viagem.via_status === "FINALIZADA" && (
            <Button
              variant="primary"
              outlined
              size="sm"
              endIcon={<IconeDownload />}
              onClick={this.handleRecibo}
            >
              Recibo
            </Button>
          )}
        </div>

        {cancelavel && (
          <div className={styles.alertaAmarelo}>
            <Info className={styles.alertaIcone} />
            <p className={styles.alertaTexto}>
              Cancelamentos podem estar sujeitos à cobrança de taxa de cancelamento.
            </p>
          </div>
        )}
      </div>
    );
  }

  renderDadosGerais() {
    const { viagem } = this.state;

    const tem_finalizacao = viagem.via_status === "FINALIZADA" && viagem.via_data_finalizacao;
    const eh_finalizada = viagem.via_status === "FINALIZADA";
    const eh_cancelada = viagem.via_status?.startsWith("CANCELADA");
    const tem_resumo = eh_finalizada || eh_cancelada;
    const tipo_veiculo = viagem.tarifa?.tar_tipo_veiculo;
    const eh_van = tipo_veiculo === "VAN";
    const cartao = viagem.cartao;
    const compromissos = viagem.agendas_compromissos || [];

    let duracao_label = "—";
    if (viagem.tarifa_valor) {
      const horas = Math.floor(viagem.tarifa_valor?.tar_duracao / 60);
      const km = parseInt(viagem.tarifa_valor?.tar_km_inclusa);
      duracao_label = `${horas}h - ${km}km`;
    }

    return (
      <div className={styles.card}>
        <p className={styles.secaoTitulo}>Dados gerais</p>

        <div className={styles.gridDuasColunas}>
          <div>
            <p className={styles.dadoLabel}>Solicitante</p>
            <p className={styles.dadoValor}>{viagem.passageiro_solicitante?.usr_nome || "—"}</p>
          </div>

          <div>
            <p className={styles.dadoLabel}>Passageiro</p>
            <p className={styles.dadoValor}>{viagem.passageiro?.usr_nome || "—"}</p>
          </div>
        </div>

        <div className={`${styles.gridDuasColunas} ${styles.campoMargem}`}>
          <div>
            <p className={styles.dadoLabel}>Data da viagem</p>
            <p className={styles.dadoValor}>{formatDateLocal(viagem.via_data_agendamento)}</p>
          </div>

          <div>
            <p className={styles.dadoLabel}>Horário de partida</p>
            <p className={styles.dadoValor}>{formatTimeLocal(viagem.via_data_agendamento)}</p>
          </div>
        </div>

        {tem_finalizacao ? (
          <div className={`${styles.gridDuasColunas} ${styles.campoMargem}`}>
            <div>
              <p className={styles.dadoLabel}>Horário de fim</p>
              <p className={styles.dadoValor}>{formatTimeLocal(viagem.via_data_finalizacao)}</p>
            </div>

            <div>
              <p className={styles.dadoLabel}>Local de partida</p>
              <p className={styles.dadoValor}>{viagem.via_origem_endereco || "—"}</p>
            </div>
          </div>
        ) : (
          <div className={styles.campoMargem}>
            <p className={styles.dadoLabel}>Local de partida</p>
            <p className={styles.dadoValor}>{viagem.via_origem_endereco || "—"}</p>
          </div>
        )}

        <hr className={styles.separador} />

        <p className={styles.secaoTitulo}>Tipo de veículo e duração da viagem</p>

        <div className={styles.veiculoBox}>
          <p className={styles.veiculoTipo}>
            {LABEL_TIPO_VEICULO[tipo_veiculo] || "—"}
          </p>

          <div className={styles.gridDuasColunas}>
            <div>
              <p className={styles.dadoLabel}>Duração da viagem</p>
              <p className={styles.dadoValor}>{duracao_label}</p>
            </div>

            <div>
              <p className={styles.dadoLabel}>Valor</p>
              <p className={styles.dadoValor}>{formatBRL(viagem.via_valor_base)}</p>
            </div>
          </div>

          {eh_van && (
            <>
              <div className={styles.campoMargem}>
                <p className={styles.dadoLabel}>Número de passageiros</p>
                <p className={styles.dadoValor}>{viagem.via_quantidade_passageiros || "—"}</p>
              </div>

              <div className={styles.campoMargem}>
                <p className={styles.dadoLabel}>Viagem excede os limites do município de partida</p>
                <p className={styles.dadoValor}>{viagem.via_excede_municipio ? "Sim" : "Não"}</p>
              </div>

              {viagem.via_excede_municipio && (
                <div className={styles.campoMargem}>
                  <p className={styles.dadoLabel}>Local de destino</p>
                  <p className={styles.dadoValor}>{viagem.via_destino_endereco || "—"}</p>
                </div>
              )}

              {viagem.via_excede_municipio && viagem.passageiros_viagem?.length > 0 && (
                <div className={styles.campoMargem}>
                  <Button
                    variant="primary"
                    outlined
                    size="sm"
                    onClick={() => this.setState({ modal_passageiros: true })}
                  >
                    Ver relação de passageiros
                  </Button>
                </div>
              )}
            </>
          )}

          {viagem.motorista && (
            <>
              <hr className={styles.divider} />

              <div className={styles.gridDuasColunas}>
                <div>
                  <p className={styles.dadoLabel}>Motorista</p>
                  <p className={styles.dadoValor}>{viagem.motorista?.mot_nome || "—"}</p>
                </div>

                <div>
                  <p className={styles.dadoLabel}>Veículo</p>
                  <p className={styles.dadoValor}>
                    {viagem.veiculo
                      ? `${viagem.veiculo.vei_placa} - ${viagem.veiculo.vei_modelo} - ${viagem.veiculo.vei_cor}`
                      : "—"}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>

        {compromissos.length > 0 && (
          <>
            <hr className={styles.separador} />

            <p className={styles.secaoTitulo}>Agenda de compromissos</p>

            {compromissos.map((compromisso, index) => {
              const isLast = index === compromissos.length - 1;

              return (
                <div key={index} className={styles.compromissoItem}>
                  <div className={styles.compromissoIconeColuna}>
                    <div className={styles.compromissoIconeCircle}>
                      <PlaceOutlined className={styles.compromissoIconeMui} />
                    </div>
                    {!isLast && <div className={styles.compromissoConector} />}
                  </div>

                  <div style={{ flex: 1, paddingBottom: isLast ? 0 : 20 }}>
                    <p className={styles.compromissoEndereco}>{compromisso.agc_endereco}</p>

                    {compromisso.agc_data_hora_prevista && (
                      <p className={styles.compromissoHorario}>
                        {formatTimeLocal(compromisso.agc_data_hora_prevista)}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        )}

        {tem_resumo && (
          <>
            <hr className={styles.separador} />

            <p className={styles.secaoTitulo}>Resumo</p>

            <div className={styles.dadoRow}>
              <p className={styles.dadoRowLabel}>Tarifa base</p>
              <p className={styles.dadoRowValor}>{formatBRL(viagem.via_valor_base)}</p>
            </div>

            {eh_finalizada && viagem.via_tempo_viagem != null && (
              <div className={styles.dadoRow}>
                <p className={styles.dadoRowLabel}>Tempo de viagem</p>
                <p className={styles.dadoRowValor}>{viagem.via_tempo_viagem} min</p>
              </div>
            )}

            <div className={styles.dadoRow}>
              <p className={styles.dadoRowLabel}>Tempo excedido</p>
              <p className={styles.dadoRowValor}>{formatBRL(viagem.via_valor_tempo_excedido || 0)}</p>
            </div>

            <div className={styles.dadoRow}>
              <p className={styles.dadoRowLabel}>Km total</p>
              <p className={styles.dadoRowValor}>{viagem.via_km_total || "0"} km</p>
            </div>

            {eh_cancelada && (
              <div className={styles.dadoRow}>
                <p className={styles.dadoRowLabel}>Taxa de cancelamento</p>
                <p className={styles.dadoRowValor}>{formatBRL(viagem.via_valor_taxa_cancelamento || 0)}</p>
              </div>
            )}

            <hr className={styles.divisorResumo} />

            <div className={styles.totalRow}>
              <p className={styles.totalLabel}>Total</p>
              <p className={styles.totalValor}>{formatBRL(viagem.via_valor_total)}</p>
            </div>

            {eh_finalizada && (
              <div className={styles.resumoBotao}>
                <Button
                  variant="default"
                  size="sm"
                  endIcon={<DescriptionOutlined />}
                  className={styles.reciboButtonCinza}
                  onClick={this.handleRecibo}
                >
                  Recibo
                </Button>
              </div>
            )}
          </>
        )}

        {cartao && (
          <>
            <hr className={styles.separador} />

            <p className={styles.secaoTitulo}>Forma de pagamento</p>

            <div className={styles.pagamentoInfo}>
              <PaymentIcon
                type={obterTipoIconeBandeira(cartao.bandeira)}
                format="logo"
                width={40}
              />

              <div>
                <p className={styles.pagamentoTexto}>
                  Cartão de crédito ****{cartao.car_ultimos_digitos}
                </p>

                <p className={styles.pagamentoValidade}>
                  {String(cartao.car_mes_validade).padStart(2, "0")}/{cartao.car_ano_validade}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }

  render() {
    const { viagem, loading } = this.state;

    if (loading) {
      return (
        <BetterCircularProgress loading={true} />
      );
    }

    if (!viagem) {
      return null;
    }

    return (
      <div className={styles.container}>
        <Breadcrumb paiTo="/viagens" paiLabel="Viagens" atual="Detalhes da viagem" />

        {this.renderStatus()}
        {this.renderDadosGerais()}
        {this.renderModalCancelar()}
        {this.renderModalPassageiros()}
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ user: auth.user });

export default connect(mapStateToProps)(ViagemShow);
